module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO55Tipsb.3129f5a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO55Tipsb.mp4
// module id = 781
// module chunks = 1